import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {UserService} from '../../../services/user/user.service';
import {HttpError, LoginError, Notification} from '../../../shared/api-error';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {ToastyService} from 'ng2-toasty';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  public loading = false;
  public submit = false;
  public loginForm: FormGroup;
  public userName: string;
  public password: string;
  public userError: string;
  private subscriptions: Subscription;
  private readonly position = 'top-center';

  constructor(private userService: UserService, private router: Router, private toastyService: ToastyService) {
    this.subscriptions = new Subscription();
    this.userName = '';
    this.password = '';
  }

  ngOnInit() {
    const userName = new FormControl('', Validators.required);
    const password = new FormControl('', Validators.required);
    this.loginForm = new FormGroup({
      userName, password
    });

    const loginSubscription = this.userService.login$
      .subscribe(
        (login: {}) => {
          this.loading = false;
          this.userService.getCurrentUser();
          this.router.navigate(['/users'])
        });

    const loginErrorSubscription = this.userService.error$
      .filter((error: HttpError) => error instanceof LoginError)
      .subscribe(
        (error: LoginError) => {
          const {message: msg = ''} = error;
          this.loading = false;
          const option = {
            title: 'Login Error',
            msg
          };
          this.toastyService.clearAll();
          this.toastyService.error(Notification.getNotification(option));
        }
      );

    this.subscriptions.add(loginErrorSubscription);
    this.subscriptions.add(loginSubscription);
  }

  login() {
    this.submit = true;
    this.userError = '';
    if (this.loginForm.valid) {
      this.loading = true;
      this.userService.login(this.userName, this.password);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}



// WEBPACK FOOTER //
// E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/app/pages/authentication/login/login.component.ts